import { ReportConfigSlugs } from '@hcs/types';

export const DEFAULT_SELECTED_COMP_LIMIT = 10;
export const NUM_HC_SUGGESTED_COMPS = 6;
export const PEXP_REPORT_CONFIG_SLUGS = [
  ReportConfigSlugs.PexpStatic,
  ReportConfigSlugs.PexpDynamic,
  ReportConfigSlugs.PexpEffectiveDateDynamic,
];
